<template>
  <Transition
    name="fadeTansition"
    appear
  >
    <div
      data-sb-regression="sb-empty-state"
      class="sb-empty-state"
    >
      <div class="sb-empty-state-container">
        <template
          v-if="iconName"
        >
          <i
            aria-hidden="true"
            :class="icoMoonClass"
          />
        </template>
        <div>
          <strong
            v-if="label"
            class="sb-empty-state-label"
          >
            <sb-text :value="label" />
          </strong>
        </div>
        <p
          v-if="description"
          class="sb-empty-state-description"
        >
          <sb-text :value="description" />
        </p>
        <!--
          @slot slot to show empty state component
        -->
        <slot />
      </div>
    </div>
  </Transition>
</template>
<script>
import SbText from '@src/components/Text/SbText.vue';

export default {
  name: 'SbEmptyState',
  components: {
    SbText,
  },
  props: {
    /**
    * The icon for the empty state
    */
    iconName: [String], //eslint-disable-line
    /**
    * The label for the empty state
    */
    label: [String], //eslint-disable-line
    /**
    * The description for the empty state
    */
    description: [String] //eslint-disable-line
  },
  computed: {
    icoMoonClass() {
      return !this.iconName ? '' : `sb-icon-${this.iconName}`;
    },
  },
};
</script>
<style lang="scss">
@import '@src/components/Table/style/sb-empty-state.scss';
</style>
